<template>
  <section class="section pt-0">
    <neighbor-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import NeighborDatatable from "./neighbor_datatable/Index.vue";

export default {
  name: "NeighborIndex",
  components: { NeighborDatatable },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    let v = this;
    v.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
